import { getApp, getApps, initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage"; // Import for Firebase Storage
import {
  getFirebaseAuthEmulatorUrl,
  shouldUseFirebaseEmulators,
} from "@/shared/utils/firebaseEmulator.utils";

const isTestMode = import.meta.env.MODE === "test";
const getFirebaseEnv = (key: keyof ImportMetaEnv, testFallback: string): string | undefined => {
  const value = import.meta.env[key];
  return value || (isTestMode ? testFallback : undefined);
};

const firebaseConfig = {
  apiKey: getFirebaseEnv("VITE_API_KEY", "test-api-key"),
  authDomain: getFirebaseEnv("VITE_AUTH_DOMAIN", "test.firebaseapp.com"),
  projectId: getFirebaseEnv("VITE_PROJECT_ID", "test-project"),
  storageBucket: getFirebaseEnv("VITE_STORAGE_BUCKET", "test.appspot.com"),
  messagingSenderId: getFirebaseEnv("VITE_MESSAGING_SENDER_ID", "1234567890"),
  appId: getFirebaseEnv("VITE_APP_ID", "1:1234567890:web:test"),
  measurementId: getFirebaseEnv("VITE_MEASUREMENT_ID", "G-TEST1234"),
};

const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

if (shouldUseFirebaseEmulators()) {
  connectAuthEmulator(auth, getFirebaseAuthEmulatorUrl());
  connectFirestoreEmulator(db, "localhost", 5002);
  connectStorageEmulator(storage, "localhost", 5005);
}
export { firebaseApp, db, storage, firebaseConfig };
